import { createTheme, responsiveFontSizes } from '@mui/material/styles';
import '@fontsource/inter/300.css';
import '@fontsource/inter/400.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';

// ===== COLOR PALETTE - DO NOT DEVIATE =====
const palette = {
  midnight: '#0f1a30',
  royal: '#2a4b8c',
  cyan: '#88c1e0',
  slate: '#6c87b2',
  white: '#ffffff',
  error: '#f44336',
  warning: '#ff9800',
  success: '#4caf50'
};

// ===== THEME CONSTRUCTION =====
export const gameshapeTheme = responsiveFontSizes(createTheme({
  palette: {
    mode: 'dark',
    primary: { main: palette.royal, dark: palette.midnight },
    secondary: { main: palette.cyan },
    error: { main: palette.error },
    warning: { main: palette.warning },
    success: { main: palette.success },
    background: { 
      default: palette.midnight,
      paper: '#131f3a',
      card: '#1a2742'
    },
    text: { 
      primary: palette.white, 
      secondary: palette.slate 
    },
    // Custom palette keys for internal use
    gameshape: palette
  },
  typography: {
    fontFamily: '"Inter", "Roboto", sans-serif',
    h1: { fontWeight: 700, fontSize: '2.5rem' },
    h2: { fontWeight: 600, fontSize: '2rem' },
    h3: { fontWeight: 600, fontSize: '1.75rem' },
    h4: { fontWeight: 600, fontSize: '1.5rem', color: palette.cyan }, // Accent headers
    h5: { fontWeight: 600, fontSize: '1.25rem' },
    h6: { fontWeight: 600, fontSize: '1rem' },
    body1: { fontSize: '0.875rem' },
    body2: { fontSize: '0.75rem', color: palette.slate }
  },
  shape: { borderRadius: 8 },
  shadows: [...Array(25).fill('none')], // Custom shadows (see shadows.js)
  components: {
    // GLOBAL OVERRIDE: Kill all default MUI styles, enforce our own
    MuiCssBaseline: {
      styleOverrides: `
        body { background: ${palette.midnight}; }
        :root { 
          --mui-primary: ${palette.royal};
          --mui-secondary: ${palette.cyan};
          --mui-bg-default: ${palette.midnight};
          --mui-bg-paper: #131f3a;
          --mui-text-primary: ${palette.white};
          --mui-text-secondary: ${palette.slate};
        }
        ::-webkit-scrollbar { width: 10px; }
        ::-webkit-scrollbar-track { background: ${palette.midnight}; }
        ::-webkit-scrollbar-thumb { background: ${palette.royal}; border-radius: 4px; }
      `
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 600,
          borderRadius: '8px',
          padding: '8px 22px'
        }
      },
      variants: [
        {
          props: { variant: 'gameshape' },
          style: {
            backgroundColor: palette.cyan,
            color: palette.midnight,
            '&:hover': { backgroundColor: '#9cd1eb' }
          }
        }
      ]
    },
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundColor: '#1a2742',
          border: `1px solid #2a3a5a`,
          borderRadius: '12px',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)'
        }
      }
    }
  }
}));

export default gameshapeTheme;